import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrollt bei Route-Wechsel automatisch nach oben.
 * Respektiert prefers-reduced-motion.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduceMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    } catch (_e) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
